import {
    FooterChildren,
    FooterTranslation,
    Language,
    Social,
    getFooter,
    getSocials,
} from '../helpers/directus';
import logo from '../../assets/logo.svg';
import facebook from '../../assets/facebook.png';
import instagram from '../../assets/instagram.png';
import linkedin from '../../assets/linkedin.png';

import translations from './footer.json';
import { createElement } from '../helpers/html';

import './footer.css';

const getTranslation = (payload: FooterTranslation[], language: Language) =>
    payload.find((i) => i.languages_code === language);

const getChildrensByLanguage = (
    payload: FooterChildren[],
    language: Language
) => {
    return payload.map(({ related_menu_item_id }) => {
        const translation = getTranslation(
            related_menu_item_id.translations,
            language
        );
        const isExternalLink = related_menu_item_id.is_link_external;

        return { ...translation, isExternalLink };
    });
};

const socialIcons: Record<Social, any> = {
    facebook: facebook,
    instagram: instagram,
    linkedin: linkedin,
};

const createSocialLinks = async (language: Language) => {
    const socials = await getSocials();
    const container = createElement('div', '', {
        class: 'footer-social-container',
    });
    socials.forEach(({ menu_item_id }) => {
        const translation = menu_item_id.translations.find(
            (t) => t.languages_code === language
        );

        const el = createElement('a', '', {
            href: translation.slug,
            target: '_blank',
            class: 'footer-social-item',
        });
        const img = createElement('img', '', {
            src: socialIcons[menu_item_id.icon.icon],
        });

        el.appendChild(img);
        container.appendChild(el);
    });
    return container;
};

const createFooterBottom = async (language: Language) => {
    const translation = translations[language];

    const textElement = createElement('p', `${translation.copyright} | `, {
        class: 'footer-bottom',
    });

    const privacyEl = createElement('a', translation.privacy_policy, {
        href: `${process.env.DOMAIN}/${language}/${translation.slug_policy}`,
        target: '_blank',
        class: 'footer-bottom-link',
    });

    textElement.appendChild(privacyEl);

    const getIndicator = () => {
        const el = createElement('span', ' | ');
        el.innerText = ' | ';
        return el;
    };
    textElement.appendChild(getIndicator());

    const noticeEl = createElement('a', translation.legal_notice, {
        href: `${process.env.DOMAIN}/${language}/${translation.slug_notice}`,
        class: 'footer-bottom-link',
        target: '_blank',
    });

    textElement.appendChild(noticeEl);

    return textElement;
};
const createLinks = async (language: Language) => {
    const footerItems = await getFooter();
    return footerItems.items.map((el) => {
        const translation = getTranslation(
            el.menu_item_id.translations,
            language
        );

        const ul = createElement('ul', '', {
            class: 'footer-category-container',
        });
        const header = createElement('h2', translation.name, {
            class: 'footer-category-title',
        });

        ul.appendChild(header);

        getChildrensByLanguage(el.menu_item_id.children, language).forEach(
            ({ name, slug, isExternalLink }) => {
                const link = createElement('a', name, {
                    class: 'footer-category-link',
                    href: isExternalLink
                        ? slug
                        : `${process.env.DOMAIN}/${language}/${slug}`,
                    target: '_blank',
                });

                const listItem = createElement('li', '', {
                    class: 'footer-category-listItem',
                });

                listItem.appendChild(link);
                ul.appendChild(listItem);
            }
        );

        return ul;
    });
};

export default async function Footer(anachor: HTMLElement, language: Language) {
    if (!anachor) throw new Error('no anachor');
    //root container
    const footerHTMLContainer = createElement('div', '', {
        class: 'footer-container',
    });

    //top part
    const footerLeft = createElement('div');
    const linkLogo = createElement('a', '', {
        href: process.env.DOMAIN,
        target: '_blank',
        class: 'footer-logo',
    });

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    linkLogo.innerHTML = logo;

    footerLeft.appendChild(linkLogo);

    const p = createElement('p', '', { class: 'footer-text' });
    const country = language === 'pl' ? 'Polska' : 'Poland';
    p.innerHTML = `Sagiton Software House Wrocław ${country} <br> web/mobile software development`;

    footerLeft.appendChild(p);

    const socials = await createSocialLinks(language);
    footerLeft.appendChild(socials);

    footerHTMLContainer.appendChild(footerLeft);

    //links part
    const htmls = await createLinks(language);
    htmls.forEach((el) => footerHTMLContainer.appendChild(el));

    //bottom part
    const bottom = await createFooterBottom(language);

    const footer = createElement('footer');
    footer.appendChild(footerHTMLContainer);
    footer.appendChild(bottom);
    anachor.append(footer);
}
